__webpack_require__.p = "/admin-minishop/";